const VisitUs = {
	init: function() {
		// console.log('VisitUs specific code');

		$('.acf-map').each(function() {
	      var map = initMap($(this));
	    });

	    $('.vu-events-item').on('click', function(){
	    	$('.vu-events-grid-wrapper').addClass('detail-view');
	    	$('.vu-events-detail-item:eq(' + $(this).index() + ')').addClass('active');
	    })

	    $('.detail-close').on('click', function(){
	    	$('.vu-events-grid-wrapper').removeClass('detail-view');
	    	$('.vu-events-detail-item').removeClass('active');
	    })

	    $('.vu-events-detail-item').each(function(){
	    	let content = $(this).find('.vu-events-detail-item-content');

	    	if(content.find('hr').length > 0){
	    		let wrap = '<div class="content-wrap">';
		    	let wrapEnd = '</div>';

		    	let html = wrap;

		    	content.children().each(function(i, e){
		    		let isLastElement = i == content.children().length -1;
		    		// console.log(isLastElement)
		    		if($(this).is('hr')){
		    			html += wrapEnd
		    		}

		    		html += this.outerHTML

		    		if($(this).is('hr')){
		    			html += wrap
		    		}

		    		if(isLastElement){
		    			html += wrapEnd
		    		}
		    	})
		    	content.empty()
		    	content.append(html);
	    	} else {
	    		content.addClass('no-flex')
	    	}
	    })
	}
}

export default VisitUs